import type { Onboarding } from "@redotech/account-common/onboarding";
import type { RedoMerchantClient } from "@redotech/redo-merchant-app-common/client";
import { getCurrentOnboarding } from "../client/onboarding";
import { isFirstInstallIntakeRequired } from "./first-install-flow";

const TERMS_REFETCH_DELAY_MS = 1500;

export interface InitialFirstInstallState {
  required: boolean;
  tcConfirmed: boolean;
  data: Onboarding;
}

// A brand-new install can race the server's onboarding-doc creation; when the
// first read says terms are still outstanding, refetch once after a short delay
// before committing.
export async function loadInitialFirstInstallState(
  client: RedoMerchantClient,
  signal: AbortSignal,
): Promise<InitialFirstInstallState> {
  const data = await getCurrentOnboarding(client, { signal });
  if (data.tcConfirmed) {
    return {
      required: isFirstInstallIntakeRequired(data),
      tcConfirmed: true,
      data,
    };
  }
  await new Promise((resolve) => setTimeout(resolve, TERMS_REFETCH_DELAY_MS));
  if (signal.aborted) {
    return { required: true, tcConfirmed: false, data };
  }
  const retry = await getCurrentOnboarding(client, { signal });
  return {
    required: isFirstInstallIntakeRequired(retry),
    tcConfirmed: retry.tcConfirmed,
    data: retry,
  };
}
